import { aiModelsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AI_MODELS_BY_ROLE_ACTION_TYPE = createNamedActions('aiModelsByRole', {
  GET_AI_MODELS_BY_ROLE_REQUEST: 'GET_AI_MODELS_BY_ROLE_REQUEST',
  GET_AI_MODELS_BY_ROLE_SUCCESS: 'GET_AI_MODELS_BY_ROLE_SUCCESS',
  GET_AI_MODELS_BY_ROLE_FAILURE: 'GET_AI_MODELS_BY_ROLE_FAILURE',
});

export const getAiModelsByRoleKey = ({ role, specialistKey }) =>
  specialistKey ? `${role}|${specialistKey}` : role;

export const getAiModelsByRoleAction = catchAsyncActionError(
  ({ role, specialistKey = null }) =>
    async dispatch => {
      const key = getAiModelsByRoleKey({ role, specialistKey });

      dispatch({
        type: AI_MODELS_BY_ROLE_ACTION_TYPE.GET_AI_MODELS_BY_ROLE_REQUEST,
        payload: { key },
      });

      try {
        const params = specialistKey ? { role, specialistKey } : { role };
        const { data } = await aiModelsApi.getAiModels(params);

        return dispatch({
          type: AI_MODELS_BY_ROLE_ACTION_TYPE.GET_AI_MODELS_BY_ROLE_SUCCESS,
          payload: { key, models: data ?? [] },
        });
      } catch (error) {
        dispatch({
          type: AI_MODELS_BY_ROLE_ACTION_TYPE.GET_AI_MODELS_BY_ROLE_FAILURE,
          payload: { key, error: error?.message ?? null },
        });

        throw error;
      }
    },
);
